import React from 'react';
import AppShell from '../../components/app-shell/app-shell';
import PublicShell from '../../components/app-shell/public-shell';
import PublicMarkdown from '../../components/markdown/public-markdown';
import markdown from './speedball-hand-lettering-journaling.md';
import GetOurFreeNewsletter from '../../components/landing-pages/get-our-free-newsletter';

const title = 'Speedball Hand Lettering Journaling';
const structuredData = {
  '@type': 'Article',
  articleBody: `Hello creative friends! I'm Melissa Esplin. I am an artist from the snow-capped mountains of Utah. I'm a self-proclaimed "Hobby Hoarder", and I'm a big believer that the best creative pursuits lie in the overlap of disciplines. Thanks for purchasing my Hand-Lettering and Journaling kit! These videos below are supplemental to the kit interactive workbook and walk you through the kit, how to use the tools and each one of the projects.`,
  name: title,
  author: 'Esplin, Melissa S',
};

export default function () {
  return (
    <AppShell seoTitle={title}>
      <PublicShell data={structuredData}>
        <GetOurFreeNewsletter />
        <PublicMarkdown markdown={markdown} />
      </PublicShell>
    </AppShell>
  );
}
